/*
  Not fully migrated, this is here to support the footer migration.
  Please check and migrate correctly
*/

import type { RouteRecordRaw } from 'vue-router'

export const A11Y = {
  STATEMENT: 'accessibility',
}

const routes: RouteRecordRaw[] = [
  {
    path: '/:locale/accessibility-statement',
    component: () => import('./Statement.vue'),
    name: A11Y.STATEMENT,
    meta: {
      disableClientSideNavigation: () => true,
    },
  },
]

export default routes
